import Reactotron, { trackGlobalErrors } from "reactotron-react-js";
import { reactotronRedux } from "reactotron-redux";
import { plugin } from "./";
var LimitlessReactotron = null;
export var getReactotron = function getReactotron() {
  if (process.env.NODE_ENV !== "production") {
    LimitlessReactotron = setupReactotron();
  }

  return LimitlessReactotron;
};
export var setupReactotron = function setupReactotron() {
  var reactotron = null; //don't run in production :)

  if (process.env.NODE_ENV !== "production") {
    reactotron = Reactotron.configure({
      name: process.env.REACT_APP_NAME
    }).use(reactotronRedux()).use(trackGlobalErrors()).use(plugin).connect();
    reactotron.clear();
  }

  return reactotron;
};